
"use client"

import { useJsApiLoader } from '@react-google-maps/api'

const libraries = ['places']

export default function GoogleMapProviderClient({
    children
}) {
    const { isLoaded: scriptLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_API_KEY,
        libraries,
    })

    if (!scriptLoaded) return null
    if (loadError) return <p>{loadError}</p>
    return children
}
